<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>Manage Wallet</h2>
            <div class="float-right">
              <button type="button" *ngIf="checkPrivilege(['super_agent'])" class="btn btn-outline-success btn-sm" (click)="triggerFundTransfer()">
                <i class="fa fa-money"></i> &nbsp;<span>Transfer Fund</span></button>

              &nbsp;<button type="button" *ngIf="checkPrivilege(['super_agent'])" class="btn btn-outline-primary btn-sm" (click)="triggerFundWallet()">
                <i class="fa fa-wallet"></i> &nbsp;<span>Fund Wallet</span></button></div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive">
              <table id="all-wallet-history" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th>#</th>
                  <th>Transaction Ref</th>
                  <!--<th>Wallet Id</th>-->
                  <th>Amount</th>
                  <th>Transaction Type</th>
                  <th>Narration</th>
                  <th>Transaction Date</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th>#</th>
                  <th>Transaction Ref</th>
                  <!--<th>Wallet Id</th>-->
                  <th>Amount</th>
                  <th>Transaction Type</th>
                  <th>Narration</th>

                  <th>Transaction Date</th>
                  <th>Action</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let transaction of transactions;let i = index;">

                  <td>{{ i + 1 }}</td>
                  <td>&nbsp;
                    {{ transaction?.transaction_id }}
                  </td>
                  <!--<td>{{ transaction?.wallet_id }}</td>-->
                  <td>
                    <span *ngIf="transaction?.is_credit" class="text-success">{{ transaction?.amount || 0 | currency: '&#8358;' }}</span>
                    <span *ngIf="!transaction?.is_credit" class="text-danger">{{ transaction?.amount || 0 | currency: '&#8358;' }}</span>
                  </td>
                  <td>
                    <span class="badge badge-success" *ngIf="transaction?.is_credit">Credit</span>
                    <span class="badge badge-danger"  *ngIf="!transaction?.is_credit">Debit</span>
                  </td>
                  <td>{{transaction?.narration}}</td>
                  <td>
                  {{ transaction?.created_at }}
                  </td>
                  <td>
                    <div>
                      <button class="btn btn-sm btn-primary" (click)="getTransactionDetails(transaction)"><i class="fa fa-eye"></i>&nbsp;Details</button>
                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>




<!-- Transaction Details Modal -->
<div class="modal fade" id="transactionDetails" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="title" id="defaultModalLabel">Transaction Details</h4>
      </div>
        <div class="modal-body">
          <div class="text-center"  *ngIf="!transactionsDetails">Loading...</div>
          <div class="table-responsive" *ngIf="transactionsDetails">
            <table class="table table-bordered table-striped">
              <tbody>
              <tr>
                <th>Payment Channel</th><td>{{transactionsDetails.payment_channel_id}}</td>
                <th>Transaction Type</th><td>{{transactionsDetails.transaction_type_id}}</td>
              </tr>
              <tr>
                <th>Narration</th><td>{{transactionsDetails.narration}}</td>
                <th>Reference</th><td>{{transactionsDetails.transaction_reference}}</td>
              </tr>
              <tr>
                <th>Status</th><td>{{transactionsDetails.transaction_status}}</td>
                <th>Amount</th><td>{{transactionsDetails.amount || 0 | currency: '&#8358;'}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">CLOSE</button>
        </div>
    </div>
  </div>
</div>


<!--Fund Transfer Modal -->
<div class="modal fade" id="fundTransfer" tabindex="-2" role="dialog">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="title" id="fundTransferModalLabel">Fund Transfer</h4>
      </div>
      <form class="form-auth-small" #fundTransferForm="ngForm" (ngSubmit)="proceedToFundTransfer()">

        <div class="modal-body">
          <div class="">
            <div class="form-group">
              <label for="selectRecipient" class="control-label">Select Recipient(Agent)</label>
              <ng-select [items]="myAgents" class="ng-select-form" #selectRecipient="ngModel" required id="selectRecipient"
                         [notFoundText]="'No recipient agent available'"
                         [placeholder]="'Select Recipient Agent'"
                         bindLabel="full_name_email"
                         bindValue="id"
                         [multiple]="false"
                         [(ngModel)]="fundTransfer.recipient_id" [ngModelOptions]="{standalone: true}" >
              </ng-select>
            </div>

            <div class="form-group">
              <label for="amount" class="control-label">Enter Amount(&#8358;)</label>

              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">NGN(&#8358;)</span>
                </div>
                <input type="number" class="form-control" placeholder="Ex: 90999" [disabled]="!fundTransfer.recipient_id"
                       #amount="ngModel"
                       id="amount" (change)="validateAmount()" (keyup)="validateAmount()"
                       [(ngModel)]="fundTransfer.amount" [ngModelOptions]="{standalone: true}" required>
              </div>
              <div class="validation-message text-danger" style="font-size: 11px;margin-top: -10px;">Wallet Balance: <b class="text-success">{{ wallet || 0 | currency: '&#8358;'}}</b></div>
            </div>
            <div class="form-group">
              <label for="narration" class="control-label">Enter Narration</label>
              <textarea class="form-control" placeholder="Enter Narration"
                     #narration="ngModel"
                     id="narration"
                        [(ngModel)]="fundTransfer.narration" [ngModelOptions]="{standalone: true}"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" *ngIf="!loaders.saving" [disabled]="selectRecipient.errors || amount.errors" class="btn btn-primary">Proceed</button>
          <span *ngIf="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
          <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
        </div>

      </form>
    </div>

  </div>
</div>

